export default __webpack_public_path__ + "static/media/Project_Filled.1ebe3568.svg";